module.exports = "<div class=\"b-park-slidedown\">\n  <button class=\"b-park-slidedown__action\" style=\"font-size: 18px;\" (click)=\"toggleState()\">\n    {{!state ? 'open' : 'close'}}\n  </button>\n  <slidedown [state]=\"state\">\n    <ng-content></ng-content>\n  </slidedown>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/slidedown/park-slidedown.html
// module id = ./src/app/dashboard/parks/park/slidedown/park-slidedown.html
// module chunks = main